module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_yq_zhxf@2x.904cd024.png";